import { render, staticRenderFns } from "./shortcodesTable.vue?vue&type=template&id=1c0b203a&"
import script from "./shortcodesTable.vue?vue&type=script&lang=js&"
export * from "./shortcodesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports